export interface DragPosition {
  x: number;
  y: number;
}

export function createDraggableModal(
  modalEl: () => HTMLElement | null
) {
  const position: DragPosition = { x: 0, y: 0 };

  let startX = 0;
  let startY = 0;
  let dragging = false;

  let baseLeft = 0;
  let baseTop = 0;
  let modalWidth = 0;
  let modalHeight = 0;

  const start = (e: MouseEvent) => {
    const el = modalEl();
    if (!el) return;

    const rect = el.getBoundingClientRect();

    // 🔑 posición REAL inicial del modal
    baseLeft = rect.left - position.x;
    baseTop = rect.top - position.y;
    modalWidth = rect.width;
    modalHeight = rect.height;

    dragging = true;
    startX = e.clientX - position.x;
    startY = e.clientY - position.y;

    document.addEventListener("mousemove", move);
    document.addEventListener("mouseup", stop);
  };

  const move = (e: MouseEvent) => {
    if (!dragging) return;

    const vw = window.innerWidth;
    const vh = window.innerHeight;

    const nextX = e.clientX - startX;
    const nextY = e.clientY - startY;

    // ✅ límites correctos respecto al viewport
    const minX = -baseLeft;
    const maxX = vw - (baseLeft + modalWidth);

    const minY = -baseTop;
    const maxY = vh - (baseTop + modalHeight);

    position.x = Math.max(minX, Math.min(nextX, maxX));
    position.y = Math.max(minY, Math.min(nextY, maxY));
  };

  const stop = () => {
    dragging = false;
    document.removeEventListener("mousemove", move);
    document.removeEventListener("mouseup", stop);
  };

  const getPosition = () => position;

  return {
    start,
    stop,
    getPosition
  };
}
